import React from 'react';
import { CheckCircle2, ChevronRight, Circle } from 'lucide-react'; // Using lucide-react icons

const ProgressNavigator = ({ currentStepKey }) => {
  const steps = [
    {
      key: 'passport',
      label: 'Service Passport',
      isCompleted: true, // Service Passport is always completed when on apply/documents page
    },
    {
      key: 'form',
      label: 'Application Form',
    },
    {
      key: 'documents',
      label: 'Eligibility Documents',
    },
  ];

  return (
    <div className="progress-navigator">
      <h3>Application Progress</h3>
      <ul>
        {steps.map((step, index) => {
          const isCurrent = step.key === currentStepKey;
          // A step is considered completed if its key comes before the current step,
          // or if it's explicitly marked as completed (like 'passport').
          // Or if the current step is 'documents', then 'form' is also completed.
          const isCompleted =
            step.isCompleted ||
            steps.findIndex(s => s.key === currentStepKey) > index ||
            (currentStepKey === 'documents' && step.key === 'form');

          let statusClass = 'pending';
          let IconComponent = Circle;

          if (isCompleted && !isCurrent) {
            statusClass = 'completed';
            IconComponent = CheckCircle2;
          } else if (isCurrent) {
            statusClass = 'current';
            IconComponent = ChevronRight;
          }

          return (
            <li key={step.key} className={statusClass}>
              <span className="icon">
                <IconComponent size={18} />
              </span>
              <span className="step-label">{step.label}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ProgressNavigator;